module.exports = __webpack_public_path__ + "static/media/map_new.52b098cc.png";